import { useCallback, useMemo } from 'react'
import { useApiQuery } from '@BUP/hooks/useApiQuery'

const mapSurveyProgress = (response, survey) => {
  if (response.status === 204) return { ...survey }

  if (typeof response.data !== 'object') {
    throw new Error(
      `The API did not return JSON. Type received: ${typeof response.data}`
    )
  }

  return { ...(response.data ?? {}), ...survey }
}

export const useGetDiagnosisProgress = (surveyData = [], options = {}) => {
  const normalizedSurveyData = useMemo(() => {
    return Array.isArray(surveyData)
      ? surveyData
        .filter(survey => survey?.id)
        .map(survey => ({
          id: survey.id,
          roleId: survey.roleId
        }))
      : []
  }, [surveyData])

  const query = useApiQuery(
    ['diagnosis-progress', normalizedSurveyData],
    'schools',
    async (client) => {
      return await Promise.all(
        normalizedSurveyData.map(async survey => {
          const response = await client.get(`diagnostic-surveys/${survey.id}/progress`)
          return mapSurveyProgress(response, survey)
        })
      )
    },
    {
      enabled: normalizedSurveyData.length > 0,
      ...options
    },
    { authenticated: true, version: 3 }
  )

  const getDiagnosisProgress = useCallback(async () => {
    return await query.refetch()
  }, [query])

  return {
    surveyProgress: Array.isArray(query.data) ? query.data : [],
    loading: query.isLoading || query.isFetching,
    isRefetching: query.isRefetching,
    error: query.isError ? query.error : null,
    getDiagnosisProgress
  }
}
